import Indicator from './Indicator'

type ProgressProps = {
  steps: { id: string; name: string }[]
  currentStep: number
}

export default function Progress({ steps, currentStep }: ProgressProps) {
  const renderIndicators = () => {
    return steps.map((step, index) => (
      <li key={`progress-${step.id}`} className="md:flex-1 max-w-[12rem]">
        <Indicator
          name={step.name}
          step={index + 1}
          totalSteps={steps.length}
          status={index === currentStep ? 'current' : index < currentStep ? 'complete' : 'upcoming'}
        />
      </li>
    ))
  }

  return (
    <nav aria-label="Progress">
      <ol role="list" className="space-y-4 md:flex md:space-y-0 md:space-x-8 md:justify-center">
        {renderIndicators()}
      </ol>
    </nav>
  )
}
